import { z } from 'zod';
import { courtSchema } from './IAemter'; // zod-Schema für ICourt
import { purchaseContractHasPersonSchema } from './IPerson'; // zod-Schema für IPurchaseContractHasPerson

export const landParcelEntrySchema = z.object({
  idLandRegister: z.number().optional(),
  idCourt: z.number().nullable(),
  Court: courtSchema.nullable().optional(),
  LandRegister: z.string(),
  SheetLandRegister: z.string(),
  Parcel: z.string(),
  LandParcel: z.string(),
});

export const realEstateSchema = z.object({
  idRealEstate: z.number(),

  Street: z.string().nullable(),
  StreetNr: z.string().nullable(),
  StreetAditional: z.string().nullable(),
  idPostcode: z.number().nullable(),
  Latitude: z.number().nullable(),
  Longitude: z.number().nullable(),

  LandParcelEntryArray: z.array(landParcelEntrySchema),

  idPropertyType: z.number(),
  isBuild: z.boolean(),
  hasApartment: z.boolean(),
  BuildWith: z.string().nullable(),
  Price: z.number(),
  PriceInventoryOption: z.number().nullable(),
  Manager_idPerson: z.number().nullable(),

  hasPartialArea: z.boolean(),
  isMeasured: z.boolean(),
  hasEasement: z.boolean(),
  PaymentMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  OrderMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  Area: z.number().nullable(),
  EasementText: z.string().nullable(),

  idRealEstateUseType: z.number(),
  Defect: z.string().nullable(),
  Particularities: z.string().nullable(),
  idPurchaseContract: z.number(),

  Postcode: z.string().optional(),
  City: z.string().optional(),

  requiresClearance: z.boolean(),
  clearanceDate: z.string(),
  isRented: z.boolean(),
  rentedPersonArray: z.array(purchaseContractHasPersonSchema),
});

export type IRealEstate = z.infer<typeof realEstateSchema>;

export type ILandParcelEntry = z.infer<typeof landParcelEntrySchema>;
